import { AbstractControl, ValidationErrors } from '@angular/forms';
import {
  PASSWORD_POLICY_CONTAIN_LOWERCASE,
  PASSWORD_POLICY_CONTAIN_NUMBER,
  PASSWORD_POLICY_CONTAIN_SPECIAL_CHARACTER,
  PASSWORD_POLICY_CONTAIN_UPPERCASE,
  PASSWORD_POLICY_MIN_LENGTH
} from '../authentication-service/authentication.service';

export function passwordStrengthValidator(control: AbstractControl): ValidationErrors | null {
  const specialCharacters = /.*[\^$*.[\]{}()?\-"!@#%&/\\,><':;|_~`+=].*/;

  const passwordImprovementTip: { [key: string]: boolean } = {};
  let invalid = false;
  if (control.value.length < PASSWORD_POLICY_MIN_LENGTH) {
    passwordImprovementTip['length'] = true;
    invalid = true;
  }
  if (PASSWORD_POLICY_CONTAIN_LOWERCASE && !/[a-z]/.test(control.value)) {
    passwordImprovementTip['lowercase'] = true;
    invalid = true;
  }
  if (PASSWORD_POLICY_CONTAIN_UPPERCASE && !/[A-Z]/.test(control.value)) {
    passwordImprovementTip['uppercase'] = true;
    invalid = true;
  }
  if (PASSWORD_POLICY_CONTAIN_NUMBER && !/[0-9]/.test(control.value)) {
    passwordImprovementTip['number'] = true;
    invalid = true;
  }
  if (
    PASSWORD_POLICY_CONTAIN_SPECIAL_CHARACTER &&
    !(specialCharacters.test(control.value) || control.value.trim().includes(' '))
  ) {
    passwordImprovementTip['specialCharacter'] = true;
    invalid = true;
  }

  if (invalid) {
    return { passwordImprovementTip: passwordImprovementTip };
  } else {
    return null;
  }
}
